<!-- 購入内容確認の下部表示 ■ ご注意 ■ など-->
<template>
  <MbBeforePurchaseCaution
    :limitedAt="bookGroup.reserved_limited_at"
    :note="masterBook.content.description_json ? masterBook.content.description_json.MbBeforePurchaseCaution : null"
    :ticketTermsUrl="masterBook.content.terms_url"
    :is0yenTicket="is0yenTicket"
  />
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  name: "TheBBCLower",
  setup() {
    const store = useStore();
    const route = useRoute();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const is0yenTicket = route.query.is_0yen_ticket == "true" ? true : false;
    return {
      masterBook,
      bookGroup,
      is0yenTicket,
    };
  },
};
</script>
